import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { FEATURES } from "../../../utils/constant";

class VehicleType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      loadingData: true,
    };
  }

  componentDidMount() {
    ReadAxios({ url: "vehicleTypeMaster" })
      .then((dataArray) => {
        console.log(dataArray);
        this.setState({
          rowData: isEmpty(dataArray) ? [] : dataArray.data.resultSet,
          loadingData: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  onCellClicked = (rowData) => {
    if (this.props.permissions.TA_VEHICLE_TYPE_MASTER.UPDATE == true) {
      typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }
  }

  onRowEdit = (rowData) => {
    this.props.history.push("/edit-vehicle-type", {
      ...rowData,
      title: "create.edit_title",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/vehicle_type");
    this.props.history.go();
  };

  render() {
    const { t } = this.props;
    const { rowData } = this.state;
    const Columns = [
      {
        headerName: t("table_header.vehicle_type_code") || "Vehicle Type Code",
        field: "vehicleTypeCode",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.vehicle_type_name") || "Vehicle Type Name",
        field: "vehicleType",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.vehicle_tonage") || "Vehicle Tonage",
        field: "vehicleTypeTonnage",
        sortable: true,
        filter: true,
      },
      // { headerName: "Vendors", field: "username", sortable: true, filter: true },
      {
        headerName: t("table_header.created_by") || "Created By",
        field: "createdBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.created_on") || "Created On",
        field: "createdOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_by") || "Modified By",
        field: "updatedBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_on") || "Modified On",
        field: "updatedOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.edit_delete") || "Edit / Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        suppressToolPanel: true,
        pinned: "right",
        hide: !this.props.permissions.TA_VEHICLE_TYPE_MASTER.UPDATE && !this.props.permissions.TA_VEHICLE_TYPE_MASTER.DELETE,
      },
    ];

    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowData}
          titleBarTitle={t("title") || "Vehicle Type"}
          titleBarLink={"/add-vehicle-type"}
          baseURL={"vehicleTypeMaster"}
          pathName={"vehicleTypeMaster"}
          keyIndex={"vehicleTypeId"}
          onEdit={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          hideRowEdit={!this.props.permissions.TA_VEHICLE_TYPE_MASTER.UPDATE}
          hideRowDelete={!this.props.permissions.TA_VEHICLE_TYPE_MASTER.DELETE}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("vehicle_type")(VehicleType));
